export const environment = {
  production: true,
  apiSOC: '#{URL_SOC}#',
  apiSmartix: '#{URL_CoreAPI}#',
  b2bIframeUrl: "https://it-d-inx-01-wa-01.azurewebsites.net/pos/productsIframe/flow"
};



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/environments/environment.ts